import { Injectable } from '@angular/core';

import { ignoreElementsTyped } from '@frontend/sports/common/core/utils/rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';

import { TeaserBetTrackingService } from './services/teaser-bet-tracking.service';
import { TeaserBetTrackingActions } from './teaser-bet-tracking.actions';

@Injectable()
export class TeaserBetTrackingEffects {
    constructor(
        private actions$: Actions,
        private trackingService: TeaserBetTrackingService,
    ) {}

    handleTrackTeaserPickRemoveEffect$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(TeaserBetTrackingActions.trackTeaserPickRemove),
                tap((action) => {
                    this.trackingService.trackTeaserPickRemove(action.payload);
                }),
                ignoreElementsTyped(),
            );
        },
        { dispatch: false },
    );

    handleTrackTeaserPointsSelectionEffect$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(TeaserBetTrackingActions.trackTeaserPointsSelection),
                tap((action) => {
                    this.trackingService.trackBetslipTeaserPointsSelection(action.payload);
                }),
                ignoreElementsTyped(),
            );
        },
        { dispatch: false },
    );

    handleTrackTeaserBetPickPriceEffect$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(TeaserBetTrackingActions.trackTeaserPickPoints),
                tap((action) => {
                    this.trackingService.trackBetslipTeaserbetsPickPointsSelection(action.payload);
                }),
                ignoreElementsTyped(),
            );
        },
        { dispatch: false },
    );

    handleTrackTeaserPointsInfoSelectionEffect$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(TeaserBetTrackingActions.trackTeaserPointsInfoSelection),
                tap((action) => {
                    this.trackingService.trackBetslipTeaserPointsInfoSelection(action.payload);
                }),
                ignoreElementsTyped(),
            );
        },
        { dispatch: false },
    );

    handleTrackTeaserErrorsEffect$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(TeaserBetTrackingActions.trackTeaserError),
                tap((action) => {
                    this.trackingService.trackTeaserErrors(action.payload);
                }),
                ignoreElementsTyped(),
            );
        },
        { dispatch: false },
    );

    handleTrackTeaserPicksLoadEffect$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(TeaserBetTrackingActions.trackTeaserPicksLoad),
                tap((action) => {
                    this.trackingService.trackBetslipTeaserPicksLoad(action.payload);
                }),
                ignoreElementsTyped(),
            );
        },
        { dispatch: false },
    );

    handleTrackTeaserPickToggleEffect$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(TeaserBetTrackingActions.trackTeaserPickToggle),
                tap((action) => {
                    this.trackingService.trackBetslipTeaserTogglePick(action.payload);
                }),
                ignoreElementsTyped(),
            );
        },
        { dispatch: false },
    );
}
